import { useEffect } from 'react';
import { useAppContext } from '../../../../../app/Context';
import { ClassStatus } from '../../../../../db/classes/types';
import { dateTimeDiff, unix } from '../../../../../utils/datetime';
import { useInterval } from '../../../../../utils/timer';
import { useClassContext } from '../../../../class/Context';
import { usePollContext } from '../../../Context';
import { getIsPollPublished } from '../../helpers';

const usePollActions = () => {
  const { isPresenting } = useAppContext();
  const { cls, setClass } = useClassContext();

  const { poll } = usePollContext();

  const isPollPublished = getIsPollPublished(poll);

  const { start, stop } = useInterval(() => {
    if (!cls?.id) {
      return;
    }

    // we do not consider OFFSET time after the class ends because server does not allow to publish activity after actual end time
    const classEndDiff = dateTimeDiff(cls.endTime, unix(), 'seconds');

    if (classEndDiff <= -1) {
      stop();

      setClass((prevVal) => {
        if (prevVal == null) return prevVal;

        return {
          ...prevVal,
          status: ClassStatus.CLOSED,
        };
      });

      return;
    }
  }, null);

  useEffect(() => {
    start(1000);
    return function cleanup() {
      stop();
    };
  }, [start, stop]);

  return { isPollPublished, isPresenting, isClassClosed: cls?.status === ClassStatus.CLOSED };
};

export default usePollActions;
